import types from './types'

export const showAllSkills = () => ({ type: types.ONBOARDING_ALL_SKILLS_SHOW })
export const hideAllSkills = () => ({ type: types.ONBOARDING_ALL_SKILLS_HIDE })
export const showSkill = (key, page = 0) => ({ type: types.ONBOARDING_SKILL_SHOW, key, page })
export const hideSkill = (key) => ({ type: types.ONBOARDING_SKILL_HIDE, key })
export const skillPage = (key, page) => ({ type: types.ONBOARDING_SKILL_PAGE, key, page })
export const finishSkill = (key) => ({ type: types.ONBOARDING_SKILL_FINISH, key })
export const dismissInfo = (key) => ({ type: types.ONBOARDING_DISMISS_INFO, key })
export const activateInfo = (key) => ({ type: types.ONBOARDING_ACTIVATE_INFO, key })
export const dismissSkillHint = () => ({ type: types.ONBOARDING_SKILL_HINT_DISMISS })

export default {
  showAllSkills,
  hideAllSkills,
  showSkill,
  hideSkill,
  skillPage,
  finishSkill,
  dismissInfo,
  activateInfo,
  dismissSkillHint,
}
